<nz-card nzTitle="Payment & Billing Info">

    <p>Confirm the customer's payment and billing information.</p>
  
    <form [formGroup]="paymentForm">
  
      <div>
  
        <!-- Card Number -->
        <div style="margin-bottom: 1rem;">
          <label>Card Number <span style="color: red;">*</span></label>
          <input
            nz-input
            placeholder="0000 0000 0000 0000"
            minlength="13"
            maxlength="16"
            type="password"
            inputmode="numeric"
            formControlName="cardNum"
          />
        </div>
  
        <!-- Name on Card -->
        <div style="margin-bottom: 1rem;">
          <label>Name on Card <span style="color: red;">*</span></label>
          <input
            nz-input
            placeholder="Enter the name as shown on card"
            formControlName="nameOnCard"
          />
        </div>
  
        <!-- Expiration Date -->
        <div style="margin-bottom: 1rem;">
          <label>Card Expiration <span style="color: red;">*</span></label>
          <input
            nz-input
            placeholder="MM/YY"
            maxlength="5"
            type="tel"
            formControlName="expDate"
            (input)="onExpInput($event)"
          />
        </div>
  
        <!-- CVV -->
        <div style="margin-bottom: 1rem;">
          <label>Card CVV <span style="color: red;">*</span></label>
          <input
            nz-input
            placeholder="CVV on back"
            type="tel"
            maxlength="4"
            minlength="3"
            formControlName="cvv"
          />
        </div>
  
        <!-- Same as Service Address -->
        <div style="margin-bottom: 1rem;">
          <label nz-checkbox formControlName="sameAsServiceAddress">
            Billing is the service address?
          </label>
        </div>
  
        <!-- Billing Address -->
        <div style="margin-bottom: 1rem;">
          <label>Address <span style="color: red;">*</span></label>
          <input
            nz-input
            placeholder="Address"
            formControlName="billingAddress"
          />
        </div>
  
        <!-- City -->
        <div style="margin-bottom: 1rem;">
          <label>City <span style="color: red;">*</span></label>
          <input
            nz-input
            placeholder="City"
            formControlName="billingCity"
          />
        </div>
  
        <!-- State + Zip -->
        <div style="display: flex; gap: 1rem; margin-bottom: 1rem;">
  
          <div style="flex: 1;">
            <label>State <span style="color: red;">*</span></label>
            <nz-select
              nzPlaceHolder="State"
              formControlName="billingState"
              style="width: 100%;"
            >
              <nz-option
                *ngFor="let s of states"
                [nzValue]="s.abbr"
                [nzLabel]="s.abbr + ' - ' + s.name"
              ></nz-option>
            </nz-select>
          </div>
  
          <div style="flex: 1;">
            <label>Zip <span style="color: red;">*</span></label>
            <input
              nz-input
              type="tel"
              maxlength="5"
              placeholder="Zip"
              formControlName="billingZip"
            />
          </div>
  
        </div>
  
      </div>
  
      <!-- Submit Button -->
      <div style="margin-top: 1.5rem;">
        <button
          nz-button
          nzType="primary"
          nzBlock
          [disabled]="paymentForm.invalid"
          (click)="submitPay()"
          [nzLoading]="submittingBtn"
        >
          Next Step
        </button>
      </div>
  
    </form>
  
  </nz-card>
  